import React from "react";
import { Box, NavigationLink, Button } from "../../../design-system";
import { NAV_LOG_IN, NAV_SIGN_UP } from "../constants/landingText";

interface AuthButtonsProps {
  onSignUpClick: () => void;
  onLogInClick: () => void;
}

const AuthButtons: React.FC<AuthButtonsProps> = ({
  onSignUpClick,
  onLogInClick,
}) => {
  return (
    <Box
      sx={{
        display: "flex",
        gap: "1rem",
        alignItems: "center",
      }}
    >
      <NavigationLink onClick={onLogInClick}>{NAV_LOG_IN}</NavigationLink>{" "}
      <Button variant="ghost" onClick={onSignUpClick}>
        {NAV_SIGN_UP}
      </Button>
    </Box>
  );
};

export default AuthButtons;
